module.exports = __webpack_public_path__ + "static/shahnaz-88143f0abe65510fe8d10e4f0241e244.jpeg";